var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dgm_wrap"},[_c('my-page-header-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }